import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {Suspense} from 'react'
import {CommentsAndReviews} from './CommentsAndReviews'
import styles from './CommentsSection.module.css'
import {CommentsAndReviewsSkeleton} from './CommentsAndReviewsSkeleton'

export function CommentsSection() {
  return (
    <section>
      <h2 className={styles.heading}>Comments</h2>
      <ErrorBoundary
        fallback="Failed to load comments"
        boundaryName="CommentsSection" /* TODO: better error fallback for comments section */
      >
        <Suspense fallback={<CommentsAndReviewsSkeleton /> /* TODO: better suspense fallback for comments section */}>
          <CommentsAndReviews />
        </Suspense>
      </ErrorBoundary>
    </section>
  )
}
